// VisualStrategy.js
import { TabPanel, TabView } from "primereact/tabview";
import { useState, useMemo } from "react";
import { useTranslation } from 'react-i18next';

import OverviewTab from "./OverviewTab";
import DetailsTab from "./DetailsTab";


const VisualStrategy = ({ data }) => {
    const { t } = useTranslation();
    const [activeIndex, setActiveIndex] = useState(0);





    const { descriptionsData, imageSources } = useMemo(() => {

        const ResponseClassificator_far = data?.processed_data?.viewing_behaviour_category?.far?.response;
        const AsymmetryClassificator_far = data?.processed_data?.viewing_behaviour_category?.far?.asymmetry;
        const key_far_response = `response=${ResponseClassificator_far}`
        const key_far_asymmetry = `asymmetry=${AsymmetryClassificator_far}`
        const key_far = `${key_far_response},${key_far_asymmetry}`;

        const ResponseClassificator_intermediate = data?.processed_data?.viewing_behaviour_category?.intermediate?.response;
        const AsymmetryClassificator_intermediate = data?.processed_data?.viewing_behaviour_category?.intermediate?.asymmetry;
        const key_intermediate_response = `response=${ResponseClassificator_intermediate}`
        const key_intermediate_asymmetry = `asymmetry=${AsymmetryClassificator_intermediate}`
        const key_intermediate = `${key_intermediate_response},${key_intermediate_asymmetry}`;


        const ResponseClassificator_near = data?.processed_data?.viewing_behaviour_category?.near?.response;
        const AsymmetryClassificator_near = data?.processed_data?.viewing_behaviour_category?.near?.asymmetry;
        const key_near_response = `response=${ResponseClassificator_near}`
        const key_near_asymmetry = `asymmetry=${AsymmetryClassificator_near}`
        const key_near = `${key_near_response},${key_near_asymmetry}`;

        const ResponseClassificator_combined = data?.processed_data?.viewing_behaviour_category?.combined?.response;
        const AsymmetryClassificator_combined = data?.processed_data?.viewing_behaviour_category?.combined?.asymmetry;
        const key_combined_response = `response=${ResponseClassificator_combined}`
        const key_combined_asymmetry = `asymmetry=${AsymmetryClassificator_combined}`

        // Fetch descriptions using t()
        const DetailsBehaviourDescription_far = t(`behaviourDescription.far.${key_far}`, { defaultValue: "" });
        const DetailsBehaviourDescription_intermediate = t(`behaviourDescription.intermediate.${key_intermediate}`, { defaultValue: "" });
        const DetailsBehaviourDescription_near = t(`behaviourDescription.near.${key_near}`, { defaultValue: "" });

        const SimpleBehaviourDescription_combined_response = t(`behaviourDescription.simple.${key_combined_response}`, { defaultValue: "" });
        const SimpleBehaviourDescription_combined_asymmetry = t(`behaviourDescription.simple.${key_combined_asymmetry}`, { defaultValue: "" });

        const SimpleBehaviourDescription_far_response = t(`behaviourDescription.simple.${key_far_response}`, { defaultValue: "" });
        const SimpleBehaviourDescription_far_asymmetry = t(`behaviourDescription.simple.${key_far_asymmetry}`, { defaultValue: "" });

        const SimpleBehaviourDescription_intermediate_response = t(`behaviourDescription.simple.${key_intermediate_response}`, { defaultValue: "" });
        const SimpleBehaviourDescription_intermediate_asymmetry = t(`behaviourDescription.simple.${key_intermediate_asymmetry}`, { defaultValue: "" });

        const SimpleBehaviourDescription_near_response = t(`behaviourDescription.simple.${key_near_response}`, { defaultValue: "" });
        const SimpleBehaviourDescription_near_asymmetry = t(`behaviourDescription.simple.${key_near_asymmetry}`, { defaultValue: "" });

        const GazAngleNearDeg = data?.processed_data?.gaze_angle_near_deg;




        // For the details tab
        const descriptionsData = {
            DetailsBehaviourDescription_far,
            DetailsBehaviourDescription_intermediate,
            DetailsBehaviourDescription_near,
            SimpleBehaviourDescription_combined_response,
            SimpleBehaviourDescription_combined_asymmetry,
            SimpleBehaviourDescription_far_response,
            SimpleBehaviourDescription_far_asymmetry,
            SimpleBehaviourDescription_intermediate_response,
            SimpleBehaviourDescription_intermediate_asymmetry,
            SimpleBehaviourDescription_near_response,
            SimpleBehaviourDescription_near_asymmetry,
            GazAngleNearDeg
        };

        const imageSources = {
            imageSrcEye_far: {
                src: data?.processed_data?.figures?.density_map_combined_eyes_far?.figureData
            },
            imageSrcEye_intermediate: {
                src: data?.processed_data?.figures?.density_map_combined_eyes_intermediate?.figureData
            },
            imageSrcEye_near: {
                src: data?.processed_data?.figures?.density_map_combined_eyes_near?.figureData
            },
            imageSrcColorScaleDensity: data?.processed_data?.figures?.density_color_scale?.figureData || "default_placeholder_image_url"
        };

        return { descriptionsData, imageSources};
    }, [data, t]);

    if (!data) {
        return <div>{t("loadingString")}</div>;
    }


    return (
        <div className="card distances-tabs relative">
            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel header={t('overview')}>
                    <OverviewTab
                        description={descriptionsData}
                        eyeMovementFactor={data?.processed_data?.eyeMovementFactor}
                        coverage={data?.processed_data?.data_coverage}

                    />
                </TabPanel>
                <TabPanel header={t('details')}>
                    <DetailsTab
                        description={descriptionsData}
                        ImageFAR={imageSources.imageSrcEye_far}
                        ImageINTERMEDIATE={imageSources.imageSrcEye_intermediate}
                        ImageNEAR = {imageSources.imageSrcEye_near}
                        eyeMovementFactor={data?.processed_data?.eyeMovementFactor}
                        eyeDirectionSizeDeg={data?.processed_data?.eye_direction_size_deg}
                    />
                </TabPanel>
            </TabView>
        </div>
    );
};

export default VisualStrategy;
